const zh = {
  "nav_home": "首页",
  "nav_about": "关于我们",
  "nav_services": "服务",
  "nav_blog": "博客",
  "nav_login": "登录",
  "nav_register": "注册",
  "nav_dashboard": "控制面板",
  "nav_logout": "退出",
  "hero_title": "全球发票融资平台",
  "hero_subtitle": "TradeFlow 是面向跨境 B2B 发票融资的数字化获客、承销和服务平台。资金由银行、保理商和私募信贷伙伴提供。",
  "hero_cta": "查看演示交易",
  "hero_secondary": "运作方式",
  "scoring_title": "初步评估",
  "scoring_subtitle": "2分钟内估算示例应收账款融资额度",
  "scoring_company": "公司名称",
  "scoring_revenue": "年收入 ($)",
  "scoring_years": "经营年限",
  "scoring_industry": "行业",
  "scoring_country": "国家",
  "scoring_invoices": "未付发票 ($)",
  "scoring_financial": "有财务报表",
  "scoring_bank": "有银行对账单",
  "scoring_submit": "计算额度",
  "scoring_result_title": "评估结果",
  "scoring_score": "评分",
  "scoring_risk": "风险等级",
  "scoring_limit": "初步额度",
  "scoring_recommendations": "建议",
  "risk_low": "低",
  "risk_moderate": "中等",
  "risk_elevated": "偏高",
  "risk_high": "高",
  "industry_manufacturing": "制造业",
  "industry_trade": "贸易",
  "industry_services": "服务业",
  "industry_logistics": "物流",
  "industry_agriculture": "农业",
  "industry_it": "信息技术",
  "industry_construction": "建筑",
  "industry_other": "其他",
  "auth_login_title": "登录",
  "auth_register_title": "创建账户",
  "auth_email": "邮箱",
  "auth_password": "密码",
  "auth_confirm_password": "确认密码",
  "auth_full_name": "全名",
  "auth_company": "公司名称",
  "auth_phone": "电话",
  "auth_role": "账户类型",
  "auth_submit_login": "登录",
  "auth_submit_register": "注册",
  "auth_no_account": "没有账户？",
  "auth_have_account": "已有账户？",
  "auth_social_login": "通过以下方式登录",
  "auth_coming_soon": "即将推出",
  "role_client_buyer": "买方 / 进口商",
  "role_client_seller": "卖方 / 出口商",
  "role_agent": "交易来源方 / 代理",
  "role_partner_investor": "投资者",
  "role_partner_institution": "银行 / 金融合作伙伴",
  "dash_overview": "概览",
  "dash_documents": "文档",
  "dash_invoices": "发票",
  "dash_deals": "交易",
  "dash_offers": "报价",
  "dash_blog": "博客",
  "dash_settings": "设置",
  "dash_analytics": "分析",
  "dash_users": "用户",
  "dash_scoring": "评分",
  "stats_total_financed": "总融资额",
  "stats_active_deals": "活跃交易",
  "stats_exposure": "可用额度",
  "stats_pending": "待审核",
  "action_upload": "上传",
  "action_create": "创建",
  "action_edit": "编辑",
  "action_delete": "删除",
  "action_view": "查看",
  "action_approve": "批准",
  "action_reject": "拒绝",
  "action_fund": "融资",
  "action_publish": "发布",
  "action_save": "保存",
  "action_cancel": "取消",
  "section_stories": "演示说明",
  "section_offers": "合作机会",
  "section_logistics": "物流服务",
  "section_how_it_works": "运作方式",
  "section_partners": "我们的合作伙伴",
  "footer_about": "关于",
  "footer_contact": "联系方式",
  "footer_terms": "服务条款",
  "footer_privacy": "隐私政策",
  "footer_copyright": "© 2024 TradeFlow. 保留所有权利。",
  "msg_success": "成功",
  "msg_error": "错误",
  "msg_loading": "加载中...",
  "msg_no_data": "暂无数据",
  "nav": {
    "demo": "演示"
  },
  "hero": {
    "badge": "全球发票融资平台",
    "statSpeedValue": "60天",
    "statSpeedLabel": "典型账期",
    "statAdvanceValue": "80%",
    "statAdvanceLabel": "示例预付款比例",
    "statPartnersValue": "4",
    "statPartnersLabel": "流程参与方",
    "approvedTitle": "演示应收账款已批准",
    "approvedMeta": "$160,000 融资申请"
  },
  "demo": {
    "badge": "示例演示交易",
    "title": "一笔跨境发票，从提交到回款",
    "subtitle": "这不是实际交易。它展示 TradeFlow 可为银行、保理商和私募信贷伙伴提供的获客、承销和服务流程。",
    "caseTitle": "Demo case: industrial equipment invoice",
    "sellerLabel": "Chinese seller",
    "buyerLabel": "Kazakhstan buyer",
    "corridorLabel": "Corridor",
    "statusLabel": "Status",
    "metrics": {
      "invoice": "Invoice",
      "term": "Payment term",
      "advance": "Advance rate",
      "financing": "Financing required",
      "pricing": "Indicative pricing",
      "fee": "TradeFlow fee"
    },
    "roles": {
      "seller": {
        "title": "Seller view",
        "items": [
          "Invoice submitted",
          "Buyer confirmed",
          "$160,000 funding ready"
        ]
      },
      "buyer": {
        "title": "Buyer view",
        "items": [
          "Invoice reviewed",
          "Payment obligation confirmed",
          "Due in 60 days"
        ]
      },
      "underwriter": {
        "title": "Underwriter view",
        "items": [
          "Risk grade B+",
          "Documents verified",
          "Recommended advance 80%"
        ]
      },
      "funder": {
        "title": "Funder view",
        "items": [
          "$160,000 deployment",
          "60-day tenor",
          "Repayment source: buyer payment"
        ]
      }
    },
    "steps": [
      {
        "title": "Seller submits invoice",
        "detail": "Chinese supplier uploads invoice, contract, shipment evidence and buyer details."
      },
      {
        "title": "Buyer confirms obligation",
        "detail": "Kazakh buyer confirms the invoice, payment date and non-dispute status."
      },
      {
        "title": "TradeFlow underwrites",
        "detail": "Seller, buyer, invoice evidence, tenor, corridor and fraud controls are scored."
      },
      {
        "title": "Funder finances receivable",
        "detail": "Bank, factor or fund deploys $160,000 against the approved receivable."
      },
      {
        "title": "Buyer repays at maturity",
        "detail": "Buyer pays $200,000 after 60 days; funder receives capital and return."
      }
    ],
    "lenderTitle": "TradeFlow is not presented as the lender in this demo.",
    "lenderText": "The platform owns origination, underwriting workflow, document evidence, confirmations and servicing. A bank, factor or credit fund finances the receivable.",
    "cta": "View workflow"
  },
  "scoring": {
    "empty": "Complete the form to receive a preliminary assessment",
    "fullAssessment": "Request full assessment",
    "industryPlaceholder": "Select industry"
  },
  "how": {
    "title": "A simple path from invoice to funding",
    "steps": [
      {
        "title": "Upload documents",
        "description": "Invoice, contract, shipment evidence and company documents are collected in one workflow."
      },
      {
        "title": "Receive assessment",
        "description": "TradeFlow scores the seller, buyer, invoice evidence, tenor and corridor."
      },
      {
        "title": "Match with funding partner",
        "description": "Approved receivables are prepared for banks, factors or credit funds."
      },
      {
        "title": "Receive proceeds",
        "description": "The seller receives the advance while TradeFlow services the transaction through repayment."
      }
    ]
  },
  "stories": {
    "title": "What the demo proves",
    "cards": [
      {
        "quote": "A bank can see the borrower, buyer, evidence package and economics in one place.",
        "author": "Funding partner",
        "company": "Kazakhstan bank / fund",
        "role": "Balance sheet provider"
      },
      {
        "quote": "A supplier can request early payment without becoming the lender or negotiating manually with each institution.",
        "author": "Chinese exporter",
        "company": "Demo Machinery Co.",
        "role": "Seller"
      },
      {
        "quote": "A buyer can confirm the commercial obligation and payment date without changing the trade relationship.",
        "author": "Kazakh importer",
        "company": "Demo Distribution LLP",
        "role": "Buyer"
      }
    ]
  },
  "offers": {
    "title": "Partner roles TradeFlow is seeking",
    "cards": [
      {
        "title": "Funding partners",
        "description": "Banks, factors and private credit funds that want qualified cross-border invoices.",
        "company": "Capital providers",
        "offer_type": "financing"
      },
      {
        "title": "Origination partners",
        "description": "Logistics, exporter and importer networks that can surface real transactions.",
        "company": "Distribution partners",
        "offer_type": "logistics"
      },
      {
        "title": "Institutional pilots",
        "description": "Kazakhstan trade-finance teams willing to test underwriting requirements on demo cases.",
        "company": "Pilot partners",
        "offer_type": "service"
      }
    ],
    "detail": "Details"
  },
  "footer": {
    "tagline": "Digital origination, underwriting and servicing for cross-border receivables finance.",
    "companyHeading": "Company",
    "servicesHeading": "Services",
    "legalHeading": "Legal",
    "careers": "Partnerships",
    "factoring": "Receivables finance",
    "tradeFinance": "Trade finance workflow",
    "bnpl": "Institutional funding rails"
  },
  "home": {
    "nav": {
      "demo": "演示交易"
    },
    "hero": {
      "badge": "全球发票融资平台",
      "statSpeedValue": "60天",
      "statSpeedLabel": "典型账期",
      "statAdvanceValue": "80%",
      "statAdvanceLabel": "示例预付款比例",
      "statPartnersValue": "4",
      "statPartnersLabel": "流程参与方",
      "approvedTitle": "演示应收账款已批准",
      "approvedMeta": "$160,000 融资申请"
    },
    "demo": {
      "badge": "示例演示交易",
      "title": "一笔跨境发票，从提交到回款",
      "subtitle": "这不是实际交易。它展示 TradeFlow 可为银行、保理商和私募信贷伙伴提供的获客、承销和服务流程。",
      "caseTitle": "演示案例：工业设备发票",
      "sellerLabel": "中国卖方",
      "buyerLabel": "哈萨克斯坦买方",
      "corridorLabel": "走廊",
      "statusLabel": "状态",
      "statusValue": "已批准融资",
      "metrics": {
        "invoice": "发票",
        "term": "付款期限",
        "advance": "预付款比例",
        "financing": "所需融资",
        "pricing": "参考定价",
        "fee": "TradeFlow 费用"
      },
      "roles": {
        "seller": {
          "title": "卖方视图",
          "items": [
            "发票已提交",
            "买方已确认",
            "$160,000 可融资"
          ]
        },
        "buyer": {
          "title": "买方视图",
          "items": [
            "发票已审核",
            "付款义务已确认",
            "60天到期"
          ]
        },
        "underwriter": {
          "title": "承销视图",
          "items": [
            "风险等级 B+",
            "文件已验证",
            "建议预付款 80%"
          ]
        },
        "funder": {
          "title": "资金方视图",
          "items": [
            "$160,000 投放",
            "60天期限",
            "还款来源：买方付款"
          ]
        }
      },
      "steps": [
        {
          "title": "卖方提交发票",
          "detail": "中国供应商上传发票、合同、发货证明和买方信息。"
        },
        {
          "title": "买方确认义务",
          "detail": "哈萨克斯坦买方确认发票、付款日期和无争议状态。"
        },
        {
          "title": "TradeFlow 承销",
          "detail": "对卖方、买方、发票证据、期限、走廊和欺诈控制进行评分。"
        },
        {
          "title": "资金方融资应收账款",
          "detail": "银行、保理商或基金针对已批准应收账款投放 $160,000。"
        },
        {
          "title": "买方到期还款",
          "detail": "60天后买方支付 $200,000；资金方收回本金和收益。"
        }
      ],
      "lenderTitle": "在此演示中，TradeFlow 不作为贷款方展示。",
      "lenderText": "平台负责获客、承销流程、文件证据、确认和服务。应收账款由银行、保理商或信贷基金融资。",
      "cta": "查看流程"
    },
    "roles": {
      "badge": "平台角色",
      "title": "选择您在交易中的角色",
      "subtitle": "TradeFlow 围绕跨境应收账款融资中的真实参与方设计，而不是一个通用用户账户。",
      "cta": "按正确角色注册",
      "items": [
        {
          "title": "卖方 / 出口商",
          "description": "上传发票、合同和发货证明；针对已确认应收账款申请提前付款。"
        },
        {
          "title": "买方 / 进口商",
          "description": "确认发票有效性、付款日期和无争议状态，使资金方可以依赖该付款义务。"
        },
        {
          "title": "交易来源方 / 代理",
          "description": "介绍卖方、买方或贸易交易，并协助准备清晰的融资材料包。"
        },
        {
          "title": "投资者",
          "description": "在配置资本前查看已批准应收账款、预期经济性、期限和风险等级。"
        },
        {
          "title": "银行 / 金融合作伙伴",
          "description": "提供资产负债表资金或保理额度，TradeFlow 负责获客、流程和服务。"
        }
      ]
    },
    "scoring": {
      "empty": "填写表单以获得初步评估",
      "fullAssessment": "申请完整评估",
      "industryPlaceholder": "选择行业",
      "companyPlaceholder": "Demo Trading LLP",
      "revenuePlaceholder": "500000",
      "invoicesPlaceholder": "200000"
    },
    "how": {
      "title": "从发票到融资的简单路径",
      "steps": [
        {
          "title": "上传文件",
          "description": "发票、合同、发货证明和公司文件集中在一个流程中。"
        },
        {
          "title": "获得评估",
          "description": "TradeFlow 评估卖方、买方、文件、期限和贸易走廊。"
        },
        {
          "title": "匹配资金伙伴",
          "description": "获批应收账款会准备给银行、保理商或信贷基金。"
        },
        {
          "title": "获得资金",
          "description": "卖方获得预付款，TradeFlow 负责服务交易直至回款。"
        }
      ]
    },
    "stories": {
      "title": "TradeFlow 演示说明什么",
      "cards": [
        {
          "quote": "银行可以在一个地方看到借款人、买方、证据包和交易经济性。",
          "author": "资金伙伴",
          "company": "哈萨克斯坦银行 / 基金",
          "role": "资金提供方"
        },
        {
          "quote": "供应商可以申请提前付款，而无需逐一与金融机构手动谈判。",
          "author": "中国出口商",
          "company": "Demo Machinery Co.",
          "role": "卖方"
        },
        {
          "quote": "买方可以确认商业义务和付款日期，而不改变贸易关系。",
          "author": "哈萨克斯坦进口商",
          "company": "Demo Distribution LLP",
          "role": "买方"
        }
      ]
    },
    "offers": {
      "title": "TradeFlow 寻找的合作伙伴",
      "detail": "详情",
      "cards": [
        {
          "title": "资金伙伴",
          "description": "希望获得合格跨境发票的银行、保理商和私募信贷基金。",
          "company": "资本提供方",
          "offer_type": "financing"
        },
        {
          "title": "获客伙伴",
          "description": "能够发现真实交易的物流、出口商和进口商网络。",
          "company": "分销伙伴",
          "offer_type": "logistics"
        },
        {
          "title": "机构试点",
          "description": "愿意用演示案例测试承销要求的哈萨克斯坦贸易融资团队。",
          "company": "试点伙伴",
          "offer_type": "service"
        }
      ]
    },
    "footer": {
      "tagline": "面向跨境应收账款融资的数字化获客、承销和服务。",
      "companyHeading": "公司",
      "servicesHeading": "服务",
      "legalHeading": "法律信息",
      "careers": "合作伙伴",
      "factoring": "应收账款融资",
      "tradeFinance": "贸易融资流程",
      "bnpl": "机构资金通道"
    }
  },
    "authPage": {
      "sideTitle": "支持跨境贸易增长的营运资金",
      "sideSubtitle": "面向跨境 B2B 交易的发票融资流程。",
      "financed": "演示规模",
      "clients": "参与方",
      "speedValue": "60天",
      "speed": "典型期限",
      "loginDescription": "登录您的账户",
      "registerDescription": "创建账户以开始流程",
      "welcome": "欢迎回来",
      "loginError": "登录失败",
      "passwordsMismatch": "密码不匹配",
      "passwordTooShort": "密码至少需要 6 个字符",
      "registerSuccess": "注册成功",
      "registerError": "注册失败",
      "fullNamePlaceholder": "Ivan Petrov",
      "companyPlaceholder": "Demo Trading LLP",
      "showPasswords": "显示密码",
      "hidePasswords": "隐藏密码"
    },
    "dashboard": {
      "clients": "客户",
      "portfolio": "投资组合",
      "search": "搜索...",
      "welcome": "欢迎",
      "accountSummary": "这是您账户中的最新情况",
      "notCompleted": "未完成",
      "users": "用户",
      "recentDeals": "最近交易",
      "noDeals": "暂无交易",
      "profile": "个人资料",
      "name": "姓名",
      "company": "公司",
      "phone": "电话",
      "interfaceLanguage": "界面语言",
      "socialAccounts": "社交账户",
      "linkedAccounts": "用于登录的已关联账户",
      "languageChanged": "语言已更改",
      "monthlyRevenue": "月收入",
      "totalDeals": "交易总数",
      "conversion": "转化率",
      "keyMetrics": "关键指标",
      "invoicesMetric": "发票",
      "activeUsers": "活跃",
      "blockedUsers": "已禁用",
      "blockUser": "禁用",
      "unblockUser": "启用",
      "offersSoon": "报价管理即将可用",
      "blogSoon": "博客管理即将可用",
      "table": {
        "amount": "金额",
        "advance": "预付款",
        "status": "状态",
        "date": "日期",
        "title": "标题",
        "type": "类型",
        "size": "大小",
        "number": "编号",
        "debtor": "债务人",
        "dueDate": "到期日",
        "fee": "费用",
        "role": "角色"
      },
      "documents": {
        "uploadTitle": "上传文件",
        "type": "文件类型",
        "title": "标题",
        "description": "描述",
        "file": "文件",
        "selectFile": "请选择文件",
        "loadError": "文件加载失败",
        "uploadSuccess": "文件已上传",
        "uploadError": "上传失败",
        "deleteSuccess": "文件已删除",
        "deleteError": "删除失败",
        "invoice": "发票",
        "financial_statement": "财务报表",
        "bank_statement": "银行流水",
        "incorporation": "公司注册文件",
        "contract": "合同",
        "other": "其他"
      },
      "invoices": {
        "createTitle": "新发票",
        "number": "发票编号",
        "debtor": "债务人",
        "issueDate": "开票日期",
        "dueDate": "到期日",
        "factoring": "保理",
        "loadError": "发票加载失败",
        "createSuccess": "发票已创建",
        "createError": "发票创建失败",
        "factoringSuccess": "保理申请已发送"
      },
      "deals": {
        "loadError": "交易加载失败",
        "approveSuccess": "交易已批准",
        "fundSuccess": "交易已融资"
      },
      "usersTab": {
        "loadError": "用户加载失败",
        "statusChanged": "状态已更改"
      },
      "status": {
        "pending_approval": "待审核",
        "pending_review": "审核中",
        "pending": "待处理",
        "approved": "已批准",
        "funded": "已融资",
        "rejected": "已拒绝",
        "active": "活跃"
      },
      "genericError": "错误"
    }
};

export default zh;
